import App from './lib/App/App.svelte';
import Banner from './lib/Banner/Banner.svelte';
import LanguagePicker from './lib/LanguagePicker/LanguagePicker.svelte';
import LoginDisabled from './lib/LoginDisabled/LoginDisabled.svelte';
import Welcome from './lib/Welcome/Welcome.svelte';

import languageController from './controllers/languageController.js';
import config from './config.js';
import { bannerStore } from './stores.js';


import 'prometheus.aaa.scss';
import 'prometheus.modern.scss';

import './theme.aaa.scss';
import './theme.modern.scss';


const languagePicker = new LanguagePicker({
    props: config,
    target: document.getElementById('language-picker')
});

languagePicker.$on('select', event => languageController.languageSelected(event));
languagePicker.$on(
    'showModal',
    () => languageController.showModal());
languagePicker.$on('hideModal', () => languageController.hideModal());

const bannerHook = document.getElementById('login-banner');
let banner;

if (bannerHook) {
    banner = new Banner({
        props: config,
        target: bannerHook
    });

    // Set banner visible after a timeout so that the live region gets rendered without a
    // banner in the first render, then updated to add the banner so that it is read aloud
    setTimeout(() => {
        const loginBannerLocalizedText = config.loginBannerLocalizedText;

        if (loginBannerLocalizedText) {
            bannerStore.set({
                bannerVisible: true,
                bannerMessage: loginBannerLocalizedText
            });
        }
    }, 0);
}

const loginDisabledHook = document.getElementById('login-disabled');
let loginDisabled;

if (loginDisabledHook) {
    loginDisabled = new LoginDisabled({
        props: config,
        target: loginDisabledHook
    });
}

const loginHook = document.getElementById('modern-login');
let app;

if (loginHook) {
    app = new App({
        target: loginHook,
        props: config
    });
}

const welcomeSection = document.getElementById('promotion');
let welcome;

if (welcomeSection){
    welcome = new Welcome({
        props: config,
        target: welcomeSection
    });
}

export default app;
